(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-form"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('custom-form')) {
    class CustomForm extends HTMLElement {
      constructor() {
        super()
        this.form = this.querySelector('form')
        this.sectionId = this.dataset.section
        this.formName = this.dataset.formName
        this.receipientEmail = this.dataset.email
        this.emailSubject = this.dataset.emailSubject

        this.form.addEventListener('submit', this.onSubmit.bind(this))
        this._formData = {}
      }

      setValues() {
        for (const elem of this.form.elements) {
          // Make sure to separate only those form values that actually belong to us, and arent app extensions
          if (elem.dataset.inputName) {
            this._formData[elem.dataset.inputName] = {
              value: elem.value,
              includeInEmail: elem.dataset.includeInEmail === 'true'
            }
          }
        }
      }

      onSubmit(event) {
        event.preventDefault()
        this.setValues()
        this.sendEmail()

        const e = new CustomEvent('email sent', { detail: this.cleanedValues })
        this.dispatchEvent(e)
      }

      sendEmail() {
        const body = Object.entries(this.values)
          .filter(([key, value]) => value.includeInEmail)
          .map(([key, value]) => `${key}: ${value.value}`)
          .join('\n')
        const link = `mailto:${this.receipientEmail}?subject=${encodeURIComponent(this.emailSubject)}&body=${encodeURIComponent(body)}`
        this.querySelector('.mailto-link').href = link
        this.querySelector('.mailto-link').click()
      }

      get values() {
        return this._formData
      }

      get cleanedValues() {
        let data = {}
        Object.entries(this._formData).forEach(([key, value]) => {
          data[key] = value.value
        })
        return data
      }
    }
    customElements.define('custom-form', CustomForm)
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super()
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header')

      this.exitTimer = null
      this.onEnterHandler = this.onEnter.bind(this)
      this.onLeaveHandler = this.onLeave.bind(this)
      this.addEventListener('mouseenter', this.onEnterHandler)
      this.addEventListener('mouseleave', this.onLeaveHandler)
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler)
      this.removeEventListener('mouseleave', this.onLeaveHandler)
    }

    onEnter() {
      this.preventClose = true
      this.header.classList.add('is-active')
      clearTimeout(this.exitTimer)
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active')
      }, 400)
    }
  }
  customElements.define('header-wrapper', HeaderWrapper)

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super()
    }

    connectedCallback() {
      super.connectedCallback()
      this.header = document.querySelector('.shopify-section-header')
      this.announcementBar = document.querySelector('.shopify-section-announcement-bar')
      if (this.announcementBar) {
        this.header.style.setProperty('--sticky-header-top', this.announcementBar.offsetHeight + 'px')
        this.setupResizeObserver()
      }
      this.discountBar = document.querySelector('#discount-message')

      this.headerBounds = {}
      this.currentScrollTop = 0
      this.preventReveal = false
      this.scrollUpActive = false

      this.onScrollHandler = this.onScroll.bind(this)
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true)

      window.addEventListener('scroll', this.onScrollHandler, false)
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp)

      this.createObserver()
    }

    setupResizeObserver() {
      this.resizeObserver = new ResizeObserver((entries) => {
        for (let entry of entries) {
          if (entry.target === this.announcementBar) {
            this.header.style.setProperty('--sticky-header-top', entry.target.offsetHeight + 'px')
            // Reset header bounds since height changed
            this.createObserver()
          }
        }
      })
      this.resizeObserver.observe(this.announcementBar)
    }

    disconnectedCallback() {
      super.connectedCallback()

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp)
      window.removeEventListener('scroll', this.onScrollHandler)
      if (this.resizeObserver && this.announcementBar) {
        this.resizeObserver.unobserve(this.announcementBar)
        this.resizeObserver.disconnect()
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop
          const boundingClientRect = entries[0].boundingClientRect

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          }
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true
        }

        observer.disconnect()
      })

      observer.observe(this.header)
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this))
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this))
          } else {
            window.clearTimeout(this.isScrolling)

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false
            }, 66)

            requestAnimationFrame(this.hide.bind(this))
          }
        } else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this))
        }
      } else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return

          requestAnimationFrame(this.hide.bind(this))

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this))
          }, 300)
        } else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this))
        }
      }

      this.currentScrollTop = scrollTop
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky')
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky')

      // When hiding the header, also hide the announcement bar
      if (this.announcementBar) {
        this.announcementBar.style.position = 'relative'
        this.announcementBar.style.top = ''
        this.announcementBar.style.width = ''
        this.announcementBar.style.zIndex = ''
      }

      if (this.discountBar) {
        this.discountBar.style.position = 'relative'
        this.discountBar.style.top = '0'
        this.discountBar.style.width = ''
        this.discountBar.style.zIndex = ''
      }

      this.header.style.top = '0'
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate')
      this.header.classList.remove('shopify-section-header-hidden')
      document.body.classList.add('shopify-body-section-header-sticky')
      document.body.classList.remove('shopify-body-section-header-hidden')

      // Ensure announcement bar sticks at the top of viewport when header is revealed
      let height = 0
      if (this.announcementBar) {
        height = height + this.announcementBar.offsetHeight
        this.announcementBar.style.position = 'fixed'
        this.announcementBar.style.top = '0'
        this.announcementBar.style.width = '100%'
        this.announcementBar.style.zIndex = '101' // Make sure it's above most elements
      }

      if (this.discountBar) {
        height = height + this.discountBar.offsetHeight
        this.discountBar.style.position = 'fixed'
        if (this.announcementBar) {
          this.discountBar.style.top = `${this.announcementBar.offsetHeight}px`
          this.discountBar.style.width = '100%'
          this.discountBar.style.zIndex = '101'
        } else {
          this.discountBar.style.top = '0'
        }
      }

      if (height > 0) {
        this.header.style.top = `${height}px`
      }
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate')

      // Reset everything back to normal state
      if (this.announcementBar) {
        this.announcementBar.style.position = 'relative'
        this.announcementBar.style.top = ''
        this.announcementBar.style.width = ''
        this.announcementBar.style.zIndex = ''
      }

      if (this.discountBar) {
        this.discountBar.style.position = 'relative'
        this.discountBar.style.top = '0'
        this.discountBar.style.width = ''
        this.discountBar.style.zIndex = ''
      }

      this.header.style.top = '0'
    }

    sticky() {
      return (
        this.header.classList.contains('shopify-section-header-sticky') &&
        !this.header.classList.contains('shopify-section-header-hidden') &&
        document.body.classList.contains('shopify-body-section-header-sticky') &&
        !document.body.classList.contains('shopify-body-section-header-hidden')
      )
    }
  }
  customElements.define('sticky-header', StickyHeader)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  const targetElement = document.getElementById('added_dynamic_block')
  if (targetElement) {
    const dataUrl = targetElement.getAttribute('data-url')
    fetch(
      dataUrl +
        '?sections=template--21752407425346__1655240249782cc7f4,template--21752407425346__ddce23bf-fcb9-4570-b8ab-77f4d17f6ae5'
    )
      .then((res) => res.json())
      .then((html) => {
        if (
          html['template--21752407425346__1655240249782cc7f4'] &&
          html['template--21752407425346__ddce23bf-fcb9-4570-b8ab-77f4d17f6ae5']
        ) {
          let htmlv =
            html['template--21752407425346__1655240249782cc7f4'] +
            html['template--21752407425346__ddce23bf-fcb9-4570-b8ab-77f4d17f6ae5']
          targetElement.innerHTML = htmlv
        }
      })
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["perfect-prenatal"] && !Shopify.designMode) return;
  try {
    
  class PrenatalQuiz extends HTMLElement {
    constructor() {
      super()
      this.journeyStages = this.querySelectorAll('div[data-stage="journey--post"]')
      this.products = this.querySelectorAll('.products--list .product')

      this.elemSelectJourney = this.querySelector('select#journey')
      this.elemSelectSick = this.querySelector('select#pregnant--sick')
      this.elemSelectAge = this.querySelector('select#conceive--age')
      this.elemSelectTrying = this.querySelector('select#conceive--trying')
      this.elemSelectSpecialist = this.querySelector('select#conceive--specialist')
      this.addEventListeners()
    }

    resetStages() {
      this.journeyStages.forEach((stage) => {
        stage.classList.toggle('hidden', true)
      })
      this.elemSelectSick.selectedIndex = 0
      this.elemSelectAge.selectedIndex = 0
      this.elemSelectTrying.selectedIndex = 0
      this.elemSelectSpecialist.selectedIndex = 0
    }

    hideProducts() {
      this.products.forEach((product) => product.classList.add('hidden'))
    }

    addEventListeners() {
      this.elemSelectJourney.addEventListener('change', this.onChangeJourney.bind(this))
      this.elemSelectSick.addEventListener('change', this.onChangePregnancy.bind(this))
      this.elemSelectAge.addEventListener('change', this.onChangeConceiveAge.bind(this))
      this.elemSelectTrying.addEventListener('change', this.onChangeConceiveTrying.bind(this))
      this.elemSelectSpecialist.addEventListener('change', this.onChangeConceiveSpecialist.bind(this))

      this.querySelectorAll('[data-product]').forEach((elem) => {
        elem.addEventListener('click', () => {
          if (gtag) {
            const data = {
              prenatalChoice: {
                product: elem.dataset.product,
                journey: elem.parentElement.dataset.journey,
                age: elem.parentElement.dataset.age,
                trying: elem.parentElement.dataset.trying,
                sick: elem.parentElement.dataset.sick,
                specialist: elem.parentElement.dataset.specialist
              }
            }
            gtag('event', 'bb-ga-choose-prenatal', data)
          }
        })
      })
    }

    toggleProducts(value, datasetToCheck) {
      this.products.forEach((product) => {
        product.classList.toggle('hidden', value !== product.dataset[datasetToCheck])
      })
    }

    onChangeJourney(e) {
      const value = e.target.value
      this.resetStages()
      this.hideProducts()
      this.elemSelectJourney.parentElement.classList.add('active')
      this.journeyStages.forEach((stage) =>
        stage.classList.toggle('hidden', this.elemSelectJourney.value !== stage.dataset.journey)
      )
      if (value === 'postpartum') {
        this.querySelector('.products--list [data-journey="postpartum"]').classList.remove('hidden')
      }
    }
    onChangePregnancy(e) {
      const value = e.target.value
      this.toggleProducts(this.elemSelectSick.value, 'sick')
      this.elemSelectSick.parentElement.classList.add('active')
    }

    onChangeConceiveAge(e) {
      const value = e.target.value
      this.hideProducts()
      this.querySelector('label[for="conceive--trying"]').classList.toggle('hidden', value !== 'under 30')
      this.elemSelectAge.parentElement.classList.add('active')
      if (value === 'over 30') {
        this.toggleProducts(this.elemSelectAge.value, 'age')
      }
    }

    onChangeConceiveTrying(e) {
      const value = e.target.value
      this.hideProducts()
      this.querySelector('label[for="conceive--specialist"]').classList.toggle('hidden', value !== 'less than 6 months')
      this.elemSelectTrying.parentElement.classList.add('active')
      if (value === 'more than 6 months') {
        this.toggleProducts(this.elemSelectTrying.value, 'trying')
      }
    }

    onChangeConceiveSpecialist(e) {
      const value = e.target.value
      this.hideProducts()
      this.elemSelectSpecialist.parentElement.classList.add('active')
      this.toggleProducts(this.elemSelectSpecialist.value, 'specialist')
    }
  }

  customElements.define('prenatal-quiz', PrenatalQuiz)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-offer-bar"] && !Shopify.designMode) return;
  try {
    
      window.addEventListener('load', (event) => {
        const thisBar = document.querySelector('.shoplift-offer--bar--sticky')

        if (thisBar != null) {
          const thisHeader = document.querySelector('.shoplift-offerbar-wrapper')
          thisHeader.classList.add('shoplift-offer-bar-sticky')

          const mainHeader = document.querySelector('#shopify-section-header > sticky-header')

          const mainInitialTop = mainHeader.offsetTop
          const stickyStart = mainHeader ? mainHeader.offsetTop + mainHeader.clientHeight : 0
          let lastScroll = window.scrollY
          document.addEventListener('scroll', (scrollEvent) => {
            if (!thisHeader) return

            // Do it quick and dirty
            const mainHidden = mainHeader && window.scrollY > lastScroll
            lastScroll = window.scrollY

            const makeSticky =
              window.pageYOffset > stickyStart ||
              (mainHeader &&
                window.pageYOffset > mainInitialTop &&
                mainHeader.parentElement.classList.contains('shopify-section-header-sticky'))

            thisHeader.classList.toggle('shoplift-offer-bar-sticky', makeSticky)

            if (!makeSticky) return

            let topPosition = 0

            if (mainHeader && !mainHidden) topPosition += mainHeader.clientHeight

            thisHeader.style.top = topPosition + 'px'
          })
        }
      })
    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["the-prenatal-for-you"] && !Shopify.designMode) return;
  try {
    
  class PrenatalForYou extends HTMLElement {
    constructor() {
      super()
      this.querySelectorAll('.button-wrapper .button').forEach((button) => {
        button.addEventListener('click', () => {
          this.resetActiveButtons()
          button.classList.add('button--active')
          this.toggleContentSection(button.dataset.value)
        })
      })

      window.addEventListener('load', (e) => {
        this.initSwipers()
      })
    }

    initSwipers() {
      this.initCategoriesSwiper()
      this.initProductsSwiper()
    }

    initCategoriesSwiper() {
      const swiperContainer = this.querySelector('swiper-container.button-inner-wrapper')
      const swiperParams = {
        loop: false,
        spaceBetween: 5,
        slideToClickedSlide: true,
        breakpoints: {
          320: {
            slidesPerView: 1.7,
            centeredSlides: true
          },
          500: {
            slidesPerView: 3,
            centeredSlides: false
          }
        }
      }
      Object.assign(swiperContainer, swiperParams)
      swiperContainer.initialize()
      this.categoriesSwiper = swiperContainer

      this.querySelectorAll('.button-wrapper button').forEach((b) =>
        b.addEventListener('click', (e) => {
          const phase = b.dataset.value
          const index = this.productsSwiper.querySelector(`swiper-slide[data-phase='${phase}']`).dataset.index
          this.productsSwiper.swiper.slideTo(index)
        })
      )
    }

    initProductsSwiper() {
      const swiperContainer = this.querySelector('swiper-container.mobile--items')

      const swiperParams = {
        loop: false,
        // autoHeight: true,
        spaceBetween: 10,
        slidesPerView: 1,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        pagination: {
          clickable: true,
          el: '.swiper-pagination'
        }
      }
      Object.assign(swiperContainer, swiperParams)
      swiperContainer.initialize()

      swiperContainer.swiper.on('slideChange', (e) => {
        if (e.slides.length) {
          const phase = e.slides[e.activeIndex].dataset.phase
          const index = this.categoriesSwiper.querySelector(`swiper-slide[data-phase='${phase}']`).dataset.index
          this.categoriesSwiper.swiper.slideTo(index - 1)

          this.resetActiveButtons()
          this.querySelector(`.button-wrapper swiper-slide:nth-child(${index}) .button`).classList.add('button--active')
        }
      })

      this.productsSwiper = swiperContainer
    }

    resetActiveButtons() {
      const buttons = this.querySelectorAll('.button-wrapper button')
      buttons.forEach((b) => {
        b.classList.remove('button--active')
      })
    }

    toggleContentSection(value) {
      const productWraps = this.querySelectorAll('.inner-content.desktop-content')
      productWraps.forEach((wrap) => {
        wrap.classList.toggle('hidden', wrap.dataset.phase !== value)
      })
    }
  }
  customElements.define('prenatal-for-you', PrenatalForYou)

  } catch(e) { console.error(e); }
})();
})();
